import { registerCustomElement, create } from '../utils.mjs';

import '../controls/toggle.mjs';
import classes from './scenario-list-item.module.scss';
import { ScenarioIconGroup } from './scenario-icon-group.mjs';
import common from '../common.module.scss';
import { I18n } from '../helpers/i18n.mjs';

export const SCENARIO_TOOL_VISIBLE_PACKAGE_COUNT = 4;
const MODULE_TOOL_VISIBLE_PACKAGE_COUNT = 1;

export class ScenarioListItem extends HTMLElement {
	static create({ id, name, disabled = false, readonly, href, packages = [], onDelete, onConfig, repository, type }) {
		const item = new ScenarioListItem();

		item.setAttribute('data-id', id);
		item.setAttribute('name', name);
		item.toggleAttribute('disabled', disabled);
		item.toggleAttribute('readonly', readonly);

		if (href) {
			item.setAttribute('href', href);
		}

		item.packages = packages;
		item.onDelete = onDelete;
		item.onConfig = onConfig;
		item.repository = repository;
		item.type = type;

		return item;
	}

	static get observedAttributes() {
		return ['name', 'enabled'];
	}

	attributeChangedCallback(name, oldValue, newValue) {
		if (name === 'name') {
			const titleElements = this.getElementsByClassName(classes.title);
			for (const element of titleElements) {
				element.textContent = newValue;
				// Update the tooltip with the new name
				jQuery(element).tooltip('dispose').tooltip({
					title: newValue,
					placement: 'top',
				});
			}
		}

		if (name === 'disabled') {
			const isDisabled = newValue != null;
			this.querySelector('imt-forman-toggle')?.toggleAttribute('checked', !isDisabled);
		}
	}

	connectedCallback() {
		this.render();
	}

	createButton({ classList = [], iconClass = '', onClick }) {
		const button = create(`button.${common.button}.${common.buttonSmall}.${common.buttonGhost}`);

		if (classList.length > 0) {
			button.classList.add(...classList);
		}

		if (iconClass) {
			button.append(create(`i.fa-regular.${iconClass}`));
		}

		if (onClick) {
			button?.addEventListener('click', onClick);
		}

		return button;
	}

	render() {
		const redirectLink = this.hasAttribute('href')
			? `<a class="${common.button} ${common.buttonSmall} ${common.buttonGhost}" href="${this.getAttribute(
					'href',
			  )}" target="_blank">
					<i class=" ${classes.linkIcon} fa-regular fa-arrow-up-right-from-square"></i>
				</a>`
			: '';

		const html = `
            <div class="${classes.item}">
                <div class="${classes.itemLeft}">
                    <div class="${classes.title}">${this.getAttribute('name')}</div>
					<div class="${common.pill}"></div>
                </div>
                <div class="${classes.actions}">
					${redirectLink}
                </div>
            </div>
        `;

		const template = document.createElement('template');
		template.insertAdjacentHTML('beforeend', html);

		const scenarioTitle = template.querySelector(`.${classes.title}`);
		jQuery(scenarioTitle).tooltip({ title: this.getAttribute('name'), placement: 'top' });

		const iconGroup = ScenarioIconGroup.create({
			packages: this.packages,
			repository: this.repository,
			visiblePackagesCount:
				this.type === 'tool' ? MODULE_TOOL_VISIBLE_PACKAGE_COUNT : SCENARIO_TOOL_VISIBLE_PACKAGE_COUNT,
		});
		template.querySelector(`.${classes.itemLeft}`)?.prepend(iconGroup);

		const actionElement = template.querySelector(`.${classes.actions}`);

		if (!this.hasAttribute('readonly')) {
			const deleteButton = this.createButton({
				classList: ['dmo-text-base'],
				iconClass: 'fa-times',
				onClick: this.onDelete,
			});
			const configButton = this.createButton({
				iconClass: 'fa-gear',
				onClick: this.onConfig,
			});

			const divider = create(`span.${classes.divider}`);

			actionElement.append(configButton, divider, deleteButton);
		}

		if (this.type === 'scenario') {
			const isDisabled = this.hasAttribute('disabled');
			const pill = template.querySelector(`.${common.pill}`);

			pill.textContent = !isDisabled ? I18n.l('scenario.active') : I18n.l('scenario.inactive');
			pill.classList.toggle(common.pillSuccess, !isDisabled);
			pill.classList.toggle(common.pillNeutral, isDisabled);

			const title = !isDisabled ? I18n.l('scenario.activeHelp') : I18n.l('scenario.inactiveHelp');
			jQuery(pill).tooltip({ title, placement: 'top' });
		}

		this.append(...template.children);
	}
}

registerCustomElement('imt-scenario-list-item', ScenarioListItem);
